<template>
    <v-card tile flat :to="link" color="grey">
        <v-img v-if="photo" :lazy-src="photo.thumbnail_file_url" :class="{'v-image__image--preload' : photo.deleting}" aspect-ratio="1" 
        :src="photo.file_url">
            <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
            </template>
        </v-img>
        <v-card-title v-else v-html="title"></v-card-title>
    </v-card>
</template>
<script>
export default {
    props: {
        photo: Object,
        title: String,
        userDetails: Object,
        link: String
    }
}
</script>